import type {
	SettingsTranslations,
	VerticalSetup,
} from "Infrastructure/Translation/Types/settings";

export const verticalSetup: VerticalSetup = {
	orderSetup: "Order setup",
	generalSetup: "General setup",
};

export const settingsTranslations: SettingsTranslations = {
	verticalSetup: verticalSetup,
};
